module.exports = __webpack_public_path__ + "static/media/lto-promo-image.cbd02302.png";